/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { string, object, bool, number, node, func, shape } from 'prop-types';
import { connect } from 'react-redux';

// import RigthArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import PersonIcon from '@material-ui/icons/AccountCircle';
import TrackIcon from '@material-ui/icons/TrackChanges';
import TruckIcon from '@material-ui/icons/LocalShipping';
import BubbleChatIcon from '@material-ui/icons/QuestionAnswer';
import MapIcon from '@material-ui/icons/Room';
import CallIcon from '@material-ui/icons/Call';
import withStyles from '@material-ui/core/styles/withStyles';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import memberDucks from '../../../../../../../../state/ducks/Member/ducks';
import { actions as tagManagerActions } from '../../../../../../../../state/ducks/TagManager';
import * as Auth from '../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/Auth/Auth';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getLanguageName } from '../../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { determineCollectionPrefixPath } from '../../../../../../../helpers/determineInternationalizationPath';
import { getDataDictionary } from '../../../../../../../../state/ducks/App/App-Selectors';

const LINKSTYLE_NORMAL = 'Normal';
const LINKSTYLE_ALTERNATE = 'Alternate';
const LINKSTYLE_DIVIDER = 'Divider';
const LINKSTYLE_BUTTON = 'Button';
// const LINKSTYLE_WIDGET = 'Widget';    TODO
const {
    common: {
        commonSelectors: { getIsAuthenticatedStatus },
    },
    auth: {
        authActions,
    },
} = memberDucks;

const styles = (theme) => ({
    toggleHeader: {
        color: theme.palette.common?.black,
        boxSizing: 'border-box',
        display: 'flex',
        fontSize: '16px',
        fontFamily: theme.typography?.fontFamily,
        textDecoration: 'none',
        position: 'relative',
        fontWeight: '400',
        textShadow: '1px 1px 1px rgba(0,0,0,.004)',
        padding: '5px 10px',
        width: '100%',
        backgroundColor: theme.palette.white,
        textAlign: 'left',
        maxWidth: '300px',
        '&:focus': {
            outline: 'none',
        },
    },
    item: {
        width: '100%',
        display: 'inline-block',
        fontSize: '14px',
        padding: '0 10px',
        color: theme.palette.preferenceOption?.color,
    },
    link: {
        color: theme.palette.preferenceOption?.color,
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        textDecoration: 'none',
        position: 'relative',
        fontWeight: '400',
        textShadow: '1px 1px 1px rgba(0,0,0,.004)',
        height: 'auto',
        marginLeft: '0',
        width: '100%',
        padding: '0',
        fontFamily: theme.typography?.fontFamily,
    },
    alternateStyleLink: {
        background: theme.palette.mobileMenuBG?.alternate || '#909090',
        display: 'block',
        fontSize: '3.5vw',
        textDecoration: 'none',
        position: 'relative',
        fontWeight: '400',
        textShadow: '1px 1px 1px rgba(255,255,255,.004)',
        height: 'auto',
        marginLeft: '0',
        width: '100%',
        padding: '10px',
        '& a': {
            color: theme.palette.white,
            fontWeight: '500',
        },
        fontFamily: theme.typography?.fontFamily,
    },
    signIn: {
        fontSize: '18px',
        fontWeight: 'bold',
        display: 'block',
        color: theme.palette.colorPrimary,
        fontFamily: theme.typography?.fontFamily,
        backgroundColor: theme.palette.colorNeutral20,
        padding: '10px',
        paddingLeft: '50px',
        marginTop: '2px',
        webkitBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        mozBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        boxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
    },
    signInIcon: {
        float: 'left',
        height: '23px',
        width: '23px',
        pointerEvent: 'none',
        display: 'inline-block',
    },
    dealsDiv: {
        backgroundColor: theme.palette.colorNeutral30,
        padding: '10px',
    },
    dealsButton: {
        backgroundColor: theme.palette.primaryButton,
        float: 'center',
        color: theme.palette.white,
        width: '100%',
        height: '40px',
    },
    spriteImgIcon: {
        paddingRight: '5px',
    },
    imgIcon: {
        width: '24px',
        height: '24px',
        marginLeft: '10px',
        marginRight: '24px',
    },
    divider: {
        boxSizing: 'border-box',
        height: '20px',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'transparent',
        marginLeft: '10px',
    },
    rightIcon: {
        position: 'absolute',
        right: '24px',
        top: '4px',
    },
    rightArrow: {
        height: '20px',
        width: '20px',
        pointerEvent: 'none',
        float: 'right',
    },
    CurrencyOption: {
        padding: '5px 10px 5px 20px',
        cursor: 'pointer',
    },
    preferenceOption: {
        marginLeft: '3px',
        fontWeight: '600',
        color: theme.palette.common?.black,
        '&>img': {
            borderRadius: '50%',
            width: '18px',
            minWidth: '17px',
            border: `2px solid ${theme.palette.common?.black}`,
            marginRight: '3px',
            verticalAlign: 'middle',
        },
    },
});

const getDataTestAttribute = (brandId, url, linkStyle, itemLabel) => {
    const link = url.split('/');
    let dataTest = '';
    if (linkStyle === LINKSTYLE_ALTERNATE) {
        const toSnakeCase = itemLabel
            .split(' ')
            .join('-')
            .toLowerCase();
        dataTest = `${'nav-menu-link-'}${toSnakeCase}`;
    } else if (link[link.length - 1].indexOf('?') >= 0) {
        const removingParams = link[link.length - 1].split('?');
        dataTest = `${removingParams[0]}${'-'}${brandId}${'-'}${'link'}`;
    } else {
        dataTest = `${link[link.length - 1]}${'-'}${brandId}${'-'}${'link'}`;
    }
    return dataTest;
};

const MenuLink = ({
    itemLink,
    classes,
    tabIndex,
    children,
    handleClose,
    brandId,
    linkStyle,
    itemLabel,
    category,
    brand,
}) => {
    try {
        if (itemLink.indexOf('://') !== -1) {
            return (
                <a
                    href={itemLink}
                    className={classes.link}
                    tabIndex={tabIndex}
                    onClick={handleClose}
                >
                    {children}
                </a>
            );
        }
    } catch (ex) {
        console.error('Failed to build menu link.', ex);
    }
    if (itemLink !== 'none') {
        const trackOrderLabel = itemLabel === 'Track Order' || itemLabel === 'Suivre votre commande';
        let linkPath = trackOrderLabel ? `${getLanguageName()}${itemLink}` : itemLink;
        if (category === 'Navigation Menu' || (category === '' && !trackOrderLabel)) {
            linkPath = brand?.code === '08F' ? determineCollectionPrefixPath(linkPath, true) : determineCollectionPrefixPath(linkPath, false);
        }
        const itemPath = trackOrderLabel ? null : linkPath;
        return (
            <Link
                data-test={getDataTestAttribute(brandId, itemLink, linkStyle, itemLabel)}
                onClick={(evt) => handleClose(evt, itemPath, category)}
                to={linkPath}
                className={classes.link}
                tabIndex={tabIndex}
            >
                {children}
            </Link>
        );
    }

    return children;
};

MenuLink.propTypes = {
    itemLink: string.isRequired,
    classes: object.isRequired,
    tabIndex: number.isRequired,
    children: node.isRequired,
    handleClose: func.isRequired,
    brandId: string.isRequired,
    linkStyle: string.isRequired,
    itemLabel: string.isRequired,
    brand: object.isRequired,
    category: string.isRequired,
};

const SlideNavMenuItem = ({
    itemType,
    itemLabel,
    itemLink,
    classes,
    icon,
    hasSubmenu,
    tabIndexMenu,
    isAuthenticated,
    handleClose,
    linkStyle,
    handleClick,
    brandId,
    trackEvent,
    processAuthPopup,
    brand,
    category,
    currentCountryData,
    language,
    currency,
    dataDictionary,
    onlyLabel,
}) => {
    /* eslint object-curly-newline: "off" */
    const iconPresets = {
        person: PersonIcon,
        target: TrackIcon,
        truck: TruckIcon,
        bubble_chat: BubbleChatIcon,
        marker: MapIcon,
        call: CallIcon,
    };
    const { auth_client_id, code } = brand;
    if (linkStyle === LINKSTYLE_DIVIDER) {
        return <div className={classes.divider} tabIndex="-1" />;
    }

    const currencyClick = () => {
        handleClose();
        // TODO: Save the selected value
    };

    const selectedLanguage = getLanguageName();

    if (linkStyle === 'Currency') {
        return (
            <div
                role="button"
                tabIndex={-1}
                onKeyDown={() => {}}
                onClick={() => currencyClick()}
                className={classes.CurrencyOption}
            >
                {itemLabel}
            </div>
        );
    }

    if (itemLabel === 'Sign In or Register' && isAuthenticated) {
        return null;
    }
    if ((itemLabel === 'Login' && isAuthenticated) || (itemLabel === 'Logout' && !isAuthenticated)) {
        return null;
    }

    // icon should be "[[preset]]" or image url
    let SpriteImgIcon = null;
    if (icon) {
        const match = icon.match(/^\[\[(\S+)\]\]$/); // e.g.  '[[person]]'
        if (match) {
            SpriteImgIcon = iconPresets[match[1]];
            SpriteImgIcon = SpriteImgIcon ? <SpriteImgIcon className={classes.spriteImgIcon} /> : null;
        } else {
            // SpriteImgIcon = <image src={icon} />;
            SpriteImgIcon = <img className={classes.imgIcon} src={icon} alt="icon" />;
        }
    }

    if (itemLabel === 'Sign In or Register') {
        return (
            <div role="presentation" onClick={handleClose}>
                <div
                    className={`${classes.signIn} ${classes.shadow}`}
                    role="button"
                    tabIndex={-1}
                    onKeyDown={() => {}}
                    onClick={async () => {
                        trackEvent({
                            eventName: 'feature_interaction', eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Normal|<<pageType>>',
                        });
                        const auth = new Auth(auth_client_id, code);
                        try {
                            const authResponse = await auth.popupLogin();
                            processAuthPopup(authResponse);
                        } catch (err) {
                            return null;
                        }
                        return true;
                    }}
                >
                    <svg
                        viewBox="0 0 24 24"
                        preserveAspectRatio="none"
                        fill="#1f1f1b"
                        focusable="false"
                        className={classes.signInIcon}
                    >
                        <g>
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </g>
                    </svg>
                    {itemLabel}
                </div>
            </div>
        );
    }

    // TODO: replace this kludgery with feature flag
    if (itemLabel === 'Welcome') {
        return null;
    }

    // TODO:  button formatting when LINKSTYLE_BUTTON
    if (linkStyle === LINKSTYLE_BUTTON) {
        return (
            <div className={classes.dealsDiv}>
                <Link to={itemLink} className={classes.link} onClick={handleClose}><Button className={classes.dealsButton}>{itemLabel}</Button></Link>
            </div>
        );
    }

    const renderPreference = () => {
        switch (itemLabel) {
            case 'Language':
            case 'Langue':
                if (language) {
                    return <span className={classes.preferenceOption}>{language}</span>;
                }
                break;
            case 'Currency':
                if (currency) {
                    return <span className={classes.preferenceOption}>{currency}</span>;
                }
                break;
            case 'Delivery Country':
                if (brand?.code === '08F' && currentCountryData && currentCountryData.icon && currentCountryData.name) {
                    return <span className={classes.preferenceOption}><img src={currentCountryData.icon} alt="img" />{currentCountryData.name} </span>;
                }
                break;
            default:
                return null;
        }
        return null;
    };

    if (onlyLabel) {
        return (
            <span>
                { /* eslint-disable no-nested-ternary */
                    selectedLanguage === '/en'
                        ? itemType === 'TopNav'
                            ? `${itemLabel}` : `${itemLabel}: `
                        : itemType === 'TopNav' ? `${dataDictionary?.[itemLabel] || itemLabel}` : `${dataDictionary?.[itemLabel] || itemLabel}: `
                }
                {renderPreference()}
            </span>
        );
    }

    if (hasSubmenu) {
        return (
            <div
                onClick={handleClick()}
                onKeyPress={handleClick()}
                role="menuitem"
                className={
                    linkStyle === LINKSTYLE_ALTERNATE ? classes.alternateStyleLink : classes.toggleHeader
                }
                tabIndex={tabIndexMenu}
            >
                {SpriteImgIcon}
                <span className={classes.item} aria-label={itemLabel}>
                    <svg
                        viewBox="0 0 24 24"
                        fill="#1f1f1b"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                        className={classes.rightArrow}
                    >
                        <g>
                            <path
                                transform="translate(1, -6),scale(1.3)"
                                d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                            />
                        </g>
                    </svg>
                    { /* eslint-disable no-nested-ternary */
                        selectedLanguage === '/en'
                            ? itemType === 'TopNav'
                                ? `${itemLabel}` : `${itemLabel}: `
                            : itemType === 'TopNav' ? `${dataDictionary?.[itemLabel] || itemLabel}` : `${dataDictionary?.[itemLabel] || itemLabel}: `
                    }
                    {renderPreference()}
                </span>
            </div>
        );
    }
    return (
        <div
            className={
                linkStyle === LINKSTYLE_ALTERNATE ? classes.alternateStyleLink : classes.toggleHeader
            }
        >
            <MenuLink
                brand={brand}
                brandId={brandId}
                itemLabel={itemLabel}
                linkStyle={linkStyle}
                itemLink={itemLink}
                classes={classes}
                tabIndex={tabIndexMenu}
                handleClose={handleClose}
                category={category}
                itemType={itemType}
            >
                {SpriteImgIcon}
                {/* this translation can be deleted when all translations are in content stack (header- menu link group) */}
                <span className={classes.item}>{ selectedLanguage === '/en' ? itemLabel : dataDictionary?.[itemLabel] || itemLabel}</span>
            </MenuLink>
        </div>
    );
};

const getBrandId = (state) => state.ui.brandId.toLowerCase();

const mapStateToProps = (state) => ({
    isAuthenticated: getIsAuthenticatedStatus(state),
    brandId: getBrandId(state),
    brand: getBrand(state),
    dataDictionary: getDataDictionary(state),
});

SlideNavMenuItem.propTypes = {
    itemLabel: string.isRequired,
    itemLink: string,
    classes: object.isRequired,
    icon: string,
    hasSubmenu: bool,
    tabIndexMenu: number,
    isAuthenticated: bool.isRequired,
    handleClose: func.isRequired,
    linkStyle: string,
    handleClick: func,
    brandId: string.isRequired,
    processAuthPopup: func.isRequired,
    trackEvent: func.isRequired,
    brand: shape({
        auth_client_id: string.isRequired,
        code: string.isRequired,
    }).isRequired,
    category: string,
    currentCountryData: shape({
        name: string.isRequired,
        icon: string.isRequired,
    }),
    language: string,
    currency: string,
    itemType: string,
    dataDictionary: object.isRequired,
    onlyLabel: bool,
};

SlideNavMenuItem.defaultProps = {
    icon: '',
    itemLink: 'none',
    hasSubmenu: false,
    tabIndexMenu: -1,
    linkStyle: LINKSTYLE_NORMAL,
    handleClick: () => {},
    currentCountryData: null,
    language: '',
    currency: '',
    category: '',
    itemType: '',
    onlyLabel: false,
};
const mapDispatchToProps = (dispatch) => ({
    processAuthPopup: bindActionCreators(authActions?.logUserSessionReady, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});
const SlideNavMenuItemStyled = withStyles(styles)(SlideNavMenuItem);
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SlideNavMenuItemStyled);
